module.exports = __webpack_public_path__ + "img/asian-beef-1.9b235c00.jpg";